/** Keep revision-bound saves ordered, including a Close request during autosave. */
export class SaveQueue {
  private tail: Promise<unknown> = Promise.resolve();
  run<T>(operation: () => Promise<T>): Promise<T> {
    const task = this.tail.catch(() => undefined).then(operation);
    this.tail = task;
    return task;
  }
}
